import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Footer = () => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    let mounted = true;

    fetch('/version.json')
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (mounted && data) {
          setVersion(data);
        }
      })
      .catch(() => {
        // Sin version.json (build local, dev server) no se muestra nada.
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (!version) {
    return null;
  }

  return (
    <Box sx={{ padding: '4px 16px', textAlign: 'right' }}>
      <Typography variant="caption" color="textSecondary">
        {`v${version.version}`}
      </Typography>
    </Box>
  );
};

export default Footer;
